import React from "react"
import SearchableMultiSelectFilter from "../../base/SearchableMultiSelectFilter"
import { commonOptions } from "@shared/lib/filters/common-options"

interface LocationFiltersProps {
  locationsValue?: string[]
  onLocationsChange?: (value: string[] | null) => void
  className?: string
}

export const LocationFilters = ({
  locationsValue = [],
  onLocationsChange,
  className,
}: LocationFiltersProps) => {
  return (
    <SearchableMultiSelectFilter
      value={locationsValue}
      onChange={onLocationsChange}
      options={commonOptions.terminalLocation}
      searchFields={['label']}
      displayTitle="Select Locations"
      searchPlaceholder="Search locations..."
      filterKey="location"
      filterLabel="Location"
      className={className}
    />
  )
}

export default React.memo(LocationFilters)